import { createContext } from "react";

interface ToastContextValue {
  toast: (message: string, variant?: "success" | "error" | "info") => void;
}

export const ToastContext = createContext<ToastContextValue | undefined>(undefined);
